import { useSelector } from 'react-redux';
import useFlagsFromBackend, { GB_FLAGS } from '../../legacy_components/services/launchDarkly';
import { COMPARE_STATUS, IS_VETTING_USEABLE, STATUS } from '../../legacy_components/constants/status';

const setPassedACCForExtraPassedInfo = (state={}) => {;
  const devFlowSteps = state.devFlowSteps
  const extraPassedInfo = state.extraPassedInfo || {};
  let passedAcc = false;
  const passed_ACC_Or_Higher_Status = COMPARE_STATUS(state.devStatus, STATUS.PASSED_CODING_CHALLENGE) >= 0 && IS_VETTING_USEABLE(state.devStatus);
  if ((devFlowSteps && devFlowSteps.step_3_passed_ACC) || state.techInterviewSchedule || state.hasSchedulingNegotiationStatus || passed_ACC_Or_Higher_Status) {
    passedAcc = true;
  }

  extraPassedInfo.passedAcc = passedAcc;
  return extraPassedInfo
}

const useProgressbarData = () => {
    const state = useSelector(state_data => {
      const { home, tests, softSkills, jobs } = state_data;
      const { devStatus, isProgrammerRole, showCloudChallenge, workExpCompleted, extraPassedInfo, coreSkillPassed  } = home;
      const { turingProfileCompleted, core_challenges, passedAdditionalMCQ } = tests
      return {
        devStatus, isProgrammerRole, showCloudChallenge, workExpCompleted, extraPassedInfo, coreSkillPassed,
        turingProfileCompleted, core_challenges, softSkills, jobs, passedAdditionalMCQ
      }
    });
    const { $flagsReady, enable_soft_skills, use_role_based_mcq_uiux } = useFlagsFromBackend([GB_FLAGS.enable_soft_skills, GB_FLAGS.use_role_based_mcq_uiux]);
    const extraPassedInfo = setPassedACCForExtraPassedInfo(state)
  return {
    currentStatus: state.devStatus,
    isProgrammerRole: state.isProgrammerRole,
    showCloudChallenge: state.showCloudChallenge,
    userJobs: state.jobs,
    extraPassedInfo,
    workExpCompleted: state.workExpCompleted,
    turingProfileCompleted: state.turingProfileCompleted,
    takenSoftSkills: state.softSkills.takenSoftSkills,
    flags: {
      enableSoftSkills: $flagsReady ? enable_soft_skills : false,
      useRoleBasedMcqUiux: $flagsReady ? use_role_based_mcq_uiux : false
    },
    coreSkillPassed: state.coreSkillPassed,
    showCoreQuiz: (state.core_challenges || []).length > 0,
    passedAdditionalMCQ: state.passedAdditionalMCQ
  };
};

export default useProgressbarData;
